export default __webpack_public_path__ + "static/media/logo_peoplewhocodes.5bf5362c.png";